
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.86674 3.23164C10.8149 1.58945 13.1851 1.58945 14.1333 3.23164L19.2739 12.1355C18.8633 12.0467 18.4371 12 18 12C15.6764 12 13.6612 13.3209 12.6645 15.2527C12.4879 15.0955 12.2551 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17C12.0281 17 12.056 16.9988 12.0835 16.9966C12.0286 17.3229 12 17.6581 12 18C12 19.3988 12.4787 20.6859 13.2812 21.7062H3.46695C1.57072 21.7062 0.385575 19.6535 1.33369 18.0113L9.86674 3.23164ZM11.574 7C10.9936 7 10.5352 7.49238 10.5765 8.07125L10.9337 13.0712C10.971 13.5946 11.4065 14 11.9311 14H12.0689C12.5935 14 13.029 13.5946 13.0663 13.0712L13.4235 8.07125C13.4648 7.49238 13.0064 7 12.426 7H11.574Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19 17.0192V18.5192L22 16.5192L19 14.5192V16.0191C17.9775 16.0097 16.9668 16.1227 16.1453 16.7145C15.3088 17.3169 14.7681 18.3399 14.5067 19.9183L15.4933 20.0816C15.7319 18.6409 16.1912 17.9138 16.7297 17.5259C17.2819 17.1282 18.0193 17.0098 18.9952 17.0191L18.9952 17.0192H19Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowabnormalThrowFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
